import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import { useTranslation } from 'react-i18next';
import HiddenLayout from './HiddenLayout';
import Hidden from './Icons/Hidden';
import Button from '../../Button';
import hiddenStyles from './Hidden.scss';
const MatureBlockedOverlay = (_param)=>{
    var { deviation , deviation: { author  } , disableMatureFilter , overrideMatureFilter  } = _param, props = _object_without_properties(_param, [
        "deviation",
        "deviation",
        "disableMatureFilter",
        "overrideMatureFilter"
    ]);
    const { t  } = useTranslation();
    return /*#__PURE__*/ React.createElement(HiddenLayout, _extends({
        deviation: deviation,
        icon: /*#__PURE__*/ React.createElement(Hidden, null),
        title: t('deviationview.blocked.mature'),
        text: props.compact ? null : t('deviationview.blocked.mature.text'),
        button: /*#__PURE__*/ React.createElement(Button, {
            view: "b14",
            height: props.compact ? 'small' : 'medium',
            onClick: overrideMatureFilter
        }, t('deviationview.blocked.displayAnyway')),
        secondaryButton: author && /*#__PURE__*/ React.createElement("button", {
            className: hiddenStyles['secondary-button'],
            onClick: disableMatureFilter
        }, t('deviationview.blocked.turnOffMatureFilter'))
    }, props));
};
MatureBlockedOverlay.displayName = 'MatureBlockedOverlay';
export default MatureBlockedOverlay;
